import Contact from 'components/Contact'
import { SEO } from 'components/seo'
import { SEO2 } from 'components/seo2'
import Intro from 'components/SignUp/Intro'
// import Layout from 'components/SignUp/Layout'
import Layout from 'components/Layout'
import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import { getSeoImage } from 'utils/googleData'

// export const Head = ({ location, params, data: { allJobPostings }, pageContext: { documentationNav } }) => {
//     return <SEO2 title="book a meeting" />
// }

export function GetInTouch({ data, location, pageContext, params, children }) {
    const { pageData, locales, documentation, tutorials, customers } = data
    const {
        body,
        excerpt,
        frontmatter,
        parent,
        fields: { slug },
    } = pageData?.nodes[0]
    const {
        title,
        subtitle,
        description,
        sidebar,
        pageStyle,
        darkMode,
        hideSurvey,
        enableStarUsBanner,
        faqs,
        enableStarUsBanner2,
        enableConversionInitiator,
        seoTitle,
        seoDescription,
        seoimage,
        demoCalenderUrl,
        qaCalenderUrl,
        demoCalenderTitle,
        qaCalenderTitle,
    } = frontmatter
    useEffect(() => {
        typeof window !== 'undefined' && window.scrollTo(0, 0)
    })
    return (
        <Layout
            crumbs={[
                {
                    title: `${title || 'book a meeting'}`,
                },
            ]}
        >
            <SEO
                title={seoTitle || 'book a meeting'}
                image={getSeoImage({ googleImages: [parent?.images, parent?.images2] }) || `/images/home.png`}
            />
            <section className="px-4">
                <Intro noLogo>
                    <Contact
                        activeTab="demo"
                        demoCalenderUrl={demoCalenderUrl}
                        qaCalenderUrl={qaCalenderUrl}
                        demoCalenderTitle={demoCalenderTitle}
                        qaCalenderTitle={qaCalenderTitle}
                        title={title}
                        subtitle={subtitle}
                        description={description}
                    />
                </Intro>
            </section>
        </Layout>
    )
}
export default GetInTouch
